import { render, staticRenderFns } from "./GInput.vue?vue&type=template&id=d0cbb342&"
import script from "./GInput.vue?vue&type=script&lang=js&"
export * from "./GInput.vue?vue&type=script&lang=js&"
import style0 from "./GInput.vue?vue&type=style&index=0&id=d0cbb342&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports